<template>
  <div class="mt-4">
    <v-card>
      <v-sheet height="64">
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <v-btn icon class="ma-2" @click="prev()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-btn icon class="ma-2" @click="next()">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          color="white"
          end="2020-11-30"
          v-model="calendar"
          type="4day"
          interval-count="0"
          @click:event="showEvent"
          :events="events"
          :event-color="getColor"
          :event-margin-bottom="20"
          :event-height="30"
          @change="updateRange"
        >
          <template v-slot:event="{ event }">
            <div class="d-flex event-class">
              <v-icon class="mx-2" color="white" small v-if="event.estado">fas fa-heart</v-icon>
              <v-icon class="mx-2" color="white" small v-else>fas fa-check</v-icon>
              <h3>{{ event.name }}</h3>
            </div>
          </template>
        </v-calendar>
        <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
          <v-card color="grey lighten-4" min-width="350px" flat>
            <v-toolbar color="red" dark>
              <v-toolbar-title>Votación</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <div class="my-8 text-center" v-if="showLoading" style="width:100% !important">
                <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
              </div>
              <div v-if="dataMenu.length > 0 ? true : false">
                <span>{{ 'Desayuno : ' + dataMenu[0].descdesayuno }}</span>
                <br />
                <span>{{ 'Almuerzo : ' + dataMenu[0].descalmuerzo }}</span>
                <br />
                <span>{{ 'Cena : ' + dataMenu[0].desccena }}</span>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="red" @click="selectedOpen = false">
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
      <div class="mt-4 text-center">
        <v-dialog v-model="dialog" persistent scrollable>
          <v-card>
            <v-tabs background-color="primary" centered dark grow>
              <v-tab>Desayuno</v-tab>
              <v-tab>Almuerzo</v-tab>
              <v-tab>Cena</v-tab>
              <v-tab-item>
                <v-container fluid>
                  <v-row>
                    <div class="my-8 text-center" v-if="showLoading" style="width:100% !important">
                      <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
                    </div>
                    <v-col v-for="(items, index) in dataMenu.D" :key="index" cols="12" md="4">
                      <v-card class="mx-auto" max-width="344" outlined>
                        <v-list-item three-line>
                          <v-list-item-content>
                            <v-list-item-title class="headline mb-1">{{ items.plato }}</v-list-item-title>
                            <v-list-item-subtitle>{{ items.plato }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-avatar tile size="80">
                            <v-img
                              :src="`https://picsum.photos/500/300?image=${5 * 3 * 5 + 10}`"
                              :lazy-src="`https://picsum.photos/10/6?image=${5 * 3 * 5 + 10}`"
                              aspect-ratio="1"
                            ></v-img>
                          </v-list-item-avatar>
                        </v-list-item>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-icon
                            v-if="!items.selected"
                            color="grey lighten-1"
                            @click="marcarVotacion(dataMenu.D, items.idprogramacioncomedor)"
                            >fas fa-heart</v-icon
                          >
                          <v-icon v-else color="red">fas fa-heart</v-icon>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
              <v-tab-item>
                <v-container fluid>
                  <v-row>
                    <v-col v-for="(items, index) in dataMenu.A" :key="index" cols="12" md="4">
                      <v-card class="mx-auto" max-width="344" outlined>
                        <v-list-item three-line>
                          <v-list-item-content>
                            <v-list-item-title class="headline mb-1">{{ items.plato }}</v-list-item-title>
                            <v-list-item-subtitle>{{ items.plato }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-avatar tile size="80">
                            <v-img
                              :src="`https://picsum.photos/500/300?image=${6 * 3 * 5 + 10}`"
                              :lazy-src="`https://picsum.photos/10/6?image=${6 * 3 * 5 + 10}`"
                              aspect-ratio="1"
                            ></v-img>
                          </v-list-item-avatar>
                        </v-list-item>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-icon
                            v-if="!items.selected"
                            color="grey lighten-1"
                            @click="marcarVotacion(dataMenu.A, items.idprogramacioncomedor)"
                            >fas fa-heart</v-icon
                          >
                          <v-icon v-else color="red">fas fa-heart</v-icon>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
              <v-tab-item>
                <v-container fluid>
                  <v-row>
                    <v-col v-for="(items, index) in dataMenu.C" :key="index" cols="12" md="4">
                      <v-card class="mx-auto" max-width="344" outlined>
                        <v-list-item three-line>
                          <v-list-item-content>
                            <v-list-item-title class="headline mb-1">{{ items.plato }}</v-list-item-title>
                            <v-list-item-subtitle>{{ items.plato }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-avatar tile size="80">
                            <v-img
                              :src="`https://picsum.photos/500/300?image=${7 * 3 * 5 + 10}`"
                              :lazy-src="`https://picsum.photos/10/6?image=${7 * 3 * 5 + 10}`"
                              aspect-ratio="1"
                            ></v-img>
                          </v-list-item-avatar>
                        </v-list-item>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-icon
                            v-if="!items.selected"
                            color="grey lighten-1"
                            @click="marcarVotacion(dataMenu.C, items.idprogramacioncomedor)"
                            >fas fa-heart</v-icon
                          >
                          <v-icon v-else color="red">fas fa-heart</v-icon>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
            </v-tabs>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" style="color:#ffffff" @click="dialog = false">
                Cancelar
              </v-btn>
              <v-btn v-if="activarBtn" @click="votarMenu()" color="primary">
                Elegir
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-card>
    <div v-if="showLoadingLista" class="progress-background">
      <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
    <v-snackbar v-model="snackbarLista" timeout="3000">
      {{ text }}
      <v-btn color="info" text @click="snackbarLista = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import VotacionEmpleadoService from '../services/VotacionEmpleadoService';

export default {
  name: 'VotacionLista',

  data: () => ({
    selectedElement: null,
    selectedOpen: false,
    showLoading: false,
    showLoadingLista: false,
    dialog: false,
    calendar: '',
    snackbarLista: false,
    start: null,
    end: null,
    tab: null,
    activarBtn: false,
    events: [
      { start: '2020-11-04', end: '2020-11-04', name: 'Pescado Frito', color: 'blue', icon: 'fas fa-heart' },
      { start: '2020-11-04', end: '2020-11-04', name: 'Pavita', color: 'yellow', icon: 'fas fa-heart' },
      { start: '2020-11-04', end: '2020-11-04', name: 'Arroz a la Cubana', color: 'orange', icon: 'fas fa-heart' },
      { start: '2020-11-05', end: '2020-11-05', name: 'Votar', color: 'green', icon: 'fas fa-check' }
    ],
    text: '',
    dataMenu: {}
  }),
  methods: {
    open() {
      this.showLoading = true;
    },
    close() {
      this.showLoading = false;
    },
    openLista() {
      this.showLoadingLista = true;
    },
    closeLista() {
      this.showLoadingLista = false;
    },
    getColor(event) {
      return event.color;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    updateRange({ start }) {
      this.calendar = start.date;
    },
    async showEvent({ event }) {
      // if (event.estado) {
      //   this.selectedElement = nativeEvent.target;
      //   this.selectedOpen = true;
      //   await this.iniciaDataMenu(event.start);
      // } else {
      if (!event.estado) {
        this.dialog = true;
        await this.iniciaDataMenu(event.start);
      }
    },
    async listaFechas() {
      this.events = [];
      this.openLista();
      const res = await this.votacionEmpleadoService.get().execResource('programacionfechas', {
        idempresa: localStorage.getItem('empjob'),
        fecha: new Date().toISOString().slice(0, 10),
        idtrabajador: localStorage.getItem('idtrabajador')
      });
      if (res.length > 0) {
        res.forEach((element) => {
          if (element.estado) {
            if (element.desayuno !== '') {
              this.events.push({
                start: element.fecha,
                end: element.fecha,
                name: `D - ${element.desayuno}`,
                color: 'blue',
                estado: element.estado
              });
            }

            if (element.almuerzo !== '') {
              this.events.push({
                start: element.fecha,
                end: element.fecha,
                name: `A - ${element.almuerzo}`,
                color: 'blue',
                estado: element.estado
              });
            }

            if (element.cena !== '') {
              this.events.push({
                start: element.fecha,
                end: element.fecha,
                name: `C - ${element.cena}`,
                color: 'blue',
                estado: element.estado
              });
            }
          }
          if (!element.estado) {
            this.events.push({
              start: element.fecha,
              end: element.fecha,
              name: 'Elegir',
              color: 'green',
              estado: element.estado
            });
          }
        });
      }
      this.closeLista();
    },
    async iniciaDataMenu(fecha) {
      this.open();
      this.dataMenu = {};
      const res = await this.votacionEmpleadoService.get().execResource('programacionplatos', {
        idempresa: localStorage.getItem('empjob'),
        usuario: localStorage.getItem('userjob'),
        fecha: fecha,
        idtrabajador: localStorage.getItem('idtrabajador')
      });
      if (res != undefined) {
        if (res.V.length > 0) {
          this.dataMenu = res.V;
        } else {
          this.dataMenu = res;
          this.activarBtn = true;

          if (this.dataMenu.D.length > 0) {
            this.dataMenu.D[0].selected = true;
          }
          if (this.dataMenu.A.length > 0) {
            this.dataMenu.A[0].selected = true;
          }
          if (this.dataMenu.C.length > 0) {
            this.dataMenu.C[0].selected = true;
          }

          /* if (this.dataMenu.V.length > 0) {
            await this.seleccionVotacion(this.dataMenu.D);
            await this.seleccionVotacion(this.dataMenu.A);
            await this.seleccionVotacion(this.dataMenu.C);
          } */
        }
      }
      this.close();
    },
    /*  seleccionVotacion(array) {
      array.forEach((elementD) => {
        this.dataMenu.V.forEach((elementV) => {
          if (elementD.idprogramacionmenu == elementV.idprogramacionmenu) {
            elementD.selected = true;
          }
        });
      });
    }, */
    marcarVotacion(array, id) {
      console.log(id);
      if (this.dataMenu.V.length == 0) {
        array.forEach((element) => {
          if (element.idprogramacioncomedor == id) {
            element.selected = true;
          } else {
            element.selected = false;
          }
        });
      }
    },
    async votarMenu() {
      let auxD = [];
      let auxA = [];
      let auxC = [];
      let resfecha = '';
      this.dataMenu.D.forEach((element) => {
        if (element.selected) {
          auxD = element;
          resfecha = element.fecha !== '' ? element.fecha : '';
        }
      });
      this.dataMenu.A.forEach((element) => {
        if (element.selected) {
          auxA = element;
          resfecha = element.fecha !== '' ? element.fecha : '';
        }
      });
      this.dataMenu.C.forEach((element) => {
        if (element.selected) {
          auxC = element;
          resfecha = element.fecha !== '' ? element.fecha : '';
        }
      });

      const res = await this.votacionEmpleadoService.post().execResource('elegirmenu', {
        idcliente: localStorage.getItem('idcliente'),
        idempresa: localStorage.getItem('empjob'),
        idprogcomdesayuno: auxD.idprogramacioncomedor,
        idprogcomalmuerzo: auxA.idprogramacioncomedor,
        idprogcomcena: auxC.idprogramacioncomedor,
        idplatodesayuno: auxD.idplato,
        idplatoalmuerzo: auxA.idplato,
        idplatocena: auxC.idplato,
        idtrabajador: localStorage.getItem('idtrabajador'),
        fecha: resfecha
      });
      if (res != undefined) {
        this.snackbarLista = true;
        this.text = res.message;
        this.dialog = false;
      }
      await this.listaFechas();
    }
  },
  async mounted() {
    this.votacionEmpleadoService = this.$httpService(new VotacionEmpleadoService(), this);
    await this.listaFechas();
  }
};
</script>
<style lang="scss" scoped>
.event-class {
  height: 100%;
  align-items: center;
}
</style>
